export default "__VITE_ASSET__YnJsKD3T__"